import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {eventsModalstoggleVisibilitySlice} from "../../slices/eventsModalstoggleVisibilitySlice";
import {StatusCodesServer} from "../../hooks";
import {RootState} from "../../store";
import GeneralUtils from "../../../utils/GeneralUtils";

export const SubscriptionsServiceApi = createApi({
    reducerPath: 'SubscriptionsServiceApi',
    baseQuery: fetchBaseQuery({
        baseUrl: GeneralUtils.getEnvironment(window.location.origin),
        prepareHeaders: (headers, { getState }) => {
            const token = (getState() as RootState).authSlice.accountInformation.token;
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        }
    }),
    endpoints: builder => ({
        addSubscriptions: builder.mutation<any, any>({
            query: (Subscription) => ({
                url: '/subscription/',
                method: 'POST',
                body: Subscription,
                headers: {
                    authorization:
                        'Bearer ' + JSON.parse(localStorage.getItem('accountInformation') || '{}').token
                }
            }),
            async onQueryStarted(_undefined, { dispatch, queryFulfilled }) {
                try {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(true)
                    );
                    await queryFulfilled;
                    StatusCodesServer(dispatch, 200);
                } catch (err: any) {
                    StatusCodesServer(dispatch, err.error.status);
                } finally {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(false)
                    );
                }
            }
        }),
        deleteSubscriptions: builder.mutation<any, any>({
            query: (Subscription) => ({
                url: '/subscription/',
                method: 'DELETE',
                body: Subscription,
                headers: {
                    authorization:
                        'Bearer ' + JSON.parse(localStorage.getItem('accountInformation') || '{}').token
                }
            }),
            async onQueryStarted(_undefined, { dispatch, queryFulfilled }) {
                try {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(true)
                    );
                    await queryFulfilled;
                    StatusCodesServer(dispatch, 200);
                } catch (err: any) {
                    StatusCodesServer(dispatch, err.error.status);
                } finally {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(false)
                    );
                }
            }
        }),
        getSubscriptions: builder.query<any, void>({
            query: () => ({
                url: '/subscription/',
                headers: {
                    authorization:
                        'Bearer ' + JSON.parse(localStorage.getItem('accountInformation') || '{}').token
                }
            }),
            transformResponse: (response: any) => {
                return {
                    ...response,
                }
            },
            async onQueryStarted(_undefined, { dispatch, queryFulfilled }) {
                try {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(true)
                    );
                    await queryFulfilled;
                    StatusCodesServer(dispatch, 200);
                } catch (err: any) {
                    StatusCodesServer(dispatch, err.error.status);
                } finally {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(false)
                    );
                }
            }
        }),
    }),
});

export const {
    useAddSubscriptionsMutation,
    useDeleteSubscriptionsMutation,
    useGetSubscriptionsQuery
} = SubscriptionsServiceApi;
